<mat-icon
    [matTooltip]="tooltip"
    [matTooltipClass]="'app-tooltip'"
    [attr.aria-label]="tooltip || 'Edit'"
    (click)="onIconClick($event)">
    edit
</mat-icon>
